// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xrjbbgnxndbpoaxzjssg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhyamJiZ254bmRicG9heHpqc3NnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk5ODA5MzUsImV4cCI6MjA2NTU1NjkzNX0.Q4ZoL4Eqw1fRHIfTbSixZnp3Ss_6CXRAlUxNa4OdlE0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);